var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof portalNavigation !== "undefined") return resolve();
	__webpack_require__.l("https://festatic.playgami.scopely.com/portal-navigation/v3_7_1/remoteEntry.js", (event) => {
		if(typeof portalNavigation !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "portalNavigation");
}).then(() => (portalNavigation));